import { apiUrl } from '../config/api'

export async function listShopItemMappings(params = {}) {
  const qs = new URLSearchParams()
  if (params.shopId) qs.set('shopId', String(params.shopId))
  const url = apiUrl(`/api/shops-shop-items${qs.toString() ? `?${qs.toString()}` : ''}`)
  const res = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'include' })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function createShopItemMapping(payload) {
  const res = await fetch(apiUrl('/api/shops-shop-items'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateShopItemMapping(id, payload) {
  const res = await fetch(apiUrl(`/api/shops-shop-items/${id}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function deleteShopItemMapping(id) {
  const res = await fetch(apiUrl(`/api/shops-shop-items/${id}`), { method: 'DELETE', credentials: 'include' })
  if (!res.ok) throw new Error(await res.text())
  return true
}
